// The pure part of confirm() (spec §2): concurrent calls are shown one at a time, FIFO,
// and every promise is settled exactly once. settle() takes the request's id, so a
// late onOpenChange(false) from a dialog that is already closing can never answer the
// NEXT request.
export function createConfirmQueue() {
  const pending = [];
  const listeners = new Set();
  let seq = 0;
  const notify = () => { for (const fn of listeners) fn(); };

  return {
    enqueue(request) {
      return new Promise((resolve) => {
        seq += 1;
        pending.push({ id: seq, request, resolve });
        if (pending.length === 1) notify();
      });
    },
    current() {
      return pending[0] ?? null;
    },
    settle(id, result) {
      const head = pending[0];
      if (!head || head.id !== id) return false;
      pending.shift();
      head.resolve(Boolean(result));
      notify();
      return true;
    },
    cancelAll() {
      if (pending.length === 0) return;
      while (pending.length) pending.shift().resolve(false);
      notify();
    },
    size() {
      return pending.length;
    },
    subscribe(fn) {
      listeners.add(fn);
      return () => { listeners.delete(fn); };
    },
  };
}
